import React from 'react';
import styles from './NavigationMenu.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquarePollHorizontal, faIcons, faBell, faCircleUser, faHeart} from '@fortawesome/free-solid-svg-icons'
import baseStyles from './Home.module.css'


const NavigationMenu = () => {

    /* Set the width of the side navigation to 250px and the left margin of the page content to 250px */
function openNav() {
    document.getElementById("mySidenav").style.width = "250px";
    document.getElementById("main").style.marginLeft = "250px";
  }
  
  /* Set the width of the side navigation to 0 and the left margin of the page content to 0 */
  function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
    document.getElementById("main").style.marginLeft = "0";
  }

  function LogOut(){
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("_id");
    localStorage.removeItem("isSubscribed");
    window.location.href = "/";
  }
  return (
    <div className={styles.sidebarContainer} >
      <h1 className={styles.logoText}><a href='/dashboard'><img id="logo" style={{width: '100%', padding: '10px'}} src='/images/logo.png'></img></a></h1>
      
        <ul style={{ display: 'flex', flexDirection: 'column', flexDirection: 'column', flexWrap: 'wrap', textAlign: 'center'}}>
            <li className='list-unstyled'><a style={{display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', fontWeight: 'bold'}} href="/dashboard"><FontAwesomeIcon icon={faSquarePollHorizontal} /> Dashboard</a></li>
            <li className='list-unstyled'><a style={{display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', fontWeight: 'bold'}} href="/dashboard"><FontAwesomeIcon icon={faIcons} /> Apps</a></li>
            <li className='list-unstyled'><a style={{fontWeight: 'normal', paddingLeft: '10px'}} href="/showcase">SHOWCASE</a></li>	
            <li className='list-unstyled'><a style={{fontWeight: 'normal', paddingLeft: '10px'}} href="/pronounce">Pronounce</a></li>
            <li className='list-unstyled'><a style={{display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', fontWeight: 'bold'}} href="/dashboard"><FontAwesomeIcon icon={faBell} /> Coming Soon</a></li>
            <li className='list-unstyled'><a style={{fontWeight: 'normal', paddingLeft: '10px'}}href="/dashboard">GoLiveBot</a></li>
            <li className='list-unstyled'><a style={{fontWeight: 'normal', paddingLeft: '10px'}}href="/dashboard">Stream+Care</a></li>
            <li className='list-unstyled'><a style={{fontWeight: 'normal', paddingLeft: '10px'}} href="/dashboard">SocialFrame</a></li>
            <li className='list-unstyled'><a style={{display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', fontWeight: 'bold'}} href="/settings"><FontAwesomeIcon icon={faCircleUser} /> Settings</a></li>
            <li className='list-unstyled'><a style={{fontWeight: 'normal', paddingLeft: '10px'}} href="/settings">Account</a></li>
            {localStorage.getItem('isSubscribed') === true || localStorage.getItem('isSubscribed') === "true" ? (
              <></>
            ) : (
              <li className='list-unstyled'><a style={{fontWeight: 'normal'}} href="/settings">Subscribe</a></li>
            )}
        </ul>
        <div className='d-flex justify-content-center' style={{padding: '10px'}}>
          <img
            src={localStorage.getItem('isSubscribed') === true || localStorage.getItem('isSubscribed') === "true" ? "/images/subscribedlogo.png" : "/images/newlogo.png"}
            style={{
              width: '100px',
              borderRadius: '100px',
              border: '5px solid #fecb00',
            }}
            alt="SuperStream Logo"
            />
        </div>
        <div className='d-flex justify-content-center' style={{padding: '10px'}}>
        {localStorage.getItem('isSubscribed') === true || localStorage.getItem('isSubscribed') === "true" ? (
          <p style={{margin: '0px'}}><span className={"medboldyellow"}>premium</span></p>
        ):(
          <p style={{margin: '0px'}}><span className={"medboldyellow"}>basic</span></p>
        )}
        </div>
        <div>
          <p style={{color: 'white'}}>#supportasmallbusiness</p>
        </div>
        <div className='d-flex justify-content-evenly' style={{padding: "10px"}}><a style={{fontWeight: 'normal'}} href="https://twitter.com/superstreamco" target="_blank"><img style={{width: '30px'}} src="/images/twitterwhite.png"></img></a>
           <a style={{fontWeight: 'normal'}} href="https://instagram.com/superstream" target="_blank"><img style={{width: '30px'}} src="/images/instawhite.png"></img></a>
           <a style={{fontWeight: 'normal'}} href="https://www.tiktok.com/@superstreamco" target="_blank"><img style={{width: '30px'}} src="/images/tiktokwhite.png"></img></a>
           <a style={{fontWeight: 'normal'}} href="https://youtube.com/channel/UCdxKHziPMLV5r2D40ABdNeQ" target="_blank"><img style={{width: '30px'}} src="/images/youtubewhite.png"></img></a></div>
        
        {/* <button onClick={LogOut} style={{margin: '10px', color: 'white'}}>Logout</button> */}
    </div>
  );
};

export default NavigationMenu;
